import axios from 'axios'
import { AUTH_REFRESH, BASE_URL, JWT_TOKEN } from 'lib/constants'

// Shared by every caller while a refresh is in flight, so a burst of parallel
// 401s renews the token once instead of once per request.
let inFlight: Promise<string | null> | null = null

// Deliberately a bare axios call rather than `postRequest` from models/api/rest:
// going through that instance would re-enter the interceptors that call this.
async function requestNewToken(): Promise<string | null> {
  const token = localStorage.getItem(JWT_TOKEN)
  if (!token) return null

  try {
    const { data } = await axios.post(
      `${BASE_URL}${AUTH_REFRESH}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    )
    if (!data?.token) return null
    localStorage.setItem(JWT_TOKEN, data.token)
    return data.token
  } catch (e) {
    return null
  }
}

// Renews the stored JWT, returning the new token or null when the session can no
// longer be renewed. The API's /auth/refresh accepts the expired token itself —
// it verifies the signature and tolerates the expiry — so there is no separate
// refresh credential to hold.
export function refreshAuthToken(): Promise<string | null> {
  if (inFlight) return inFlight

  inFlight = requestNewToken().finally(() => {
    inFlight = null
  })

  return inFlight
}
